import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './floating-icon.css';
import './admin/admin.css';
import ErrorBoundary from './ErrorBoundary';
import Public from './pages/Public';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Public />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminLayout />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
